import { render } from "./SupervisorManagement.vue?vue&type=template&id=47acfdea"
import script from "./SupervisorManagement.vue?vue&type=script&lang=js"
export * from "./SupervisorManagement.vue?vue&type=script&lang=js"

import "./SupervisorManagement.vue?vue&type=style&index=0&id=47acfdea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__